<template>
    <section>
        <div class="container">
            <template v-if="hasPermission">
                <div class="flex justify-between">
                    <h2 class="font-medium text-md mobile:text-base">{{translate('jaarrekeningen')}}</h2>
                    <div class="flex gap-3 items-center">
                        <a :aria-label="translate('add_to_comparison')" href="" v-if="detailStore.hasRecentBalans && detailStore.isBelgian && !detailStore.isRegsol" v-on:click.prevent="store.addToComparison(detailStore.vat)" 
                        class="btn btn-sm">
                            <i class="far fa-down-left-and-up-right-to-center rotate-45 mr-1"></i>
                            {{translate('add_to_comparison')}}
                        </a>
                        <a :href="model?.exportLink" class="btn btn-sm" :disabled="!hasData">
                            <i class="mr-1 far fa-download"></i> {{translate('overzicht')}}
                        </a>
                        <div v-if="model?.detailedExportData.length > 0">
                            <div class="group relative z-10 tablet:hidden" v-on:mouseover.prevent="isMenuOpen = true" v-on:mouseleave.prevent="isMenuOpen = false" >
                                <div class="overflow-hidden" >
                                    <a class="btn btn-sm">
                                        <i class="mr-1 far fa-download"></i> {{translate('detail')}}
                                    </a>
                                </div>

                                <div class="absolute right-0 w-24 pt-2"  v-if="isMenuOpen" v-cloak>
                                    <div class="bg-white border border-grey-300 rounded-md shadow-sm">
                                        <ul class="divide-grey-300 divide-y">
                                            <li v-for="row in model?.detailedExportData">
                                                <a class="font-medium hover:bg-grey-100 px-4 py-2 text-sm w-full text-right flex items-center gap-2" :href="row.link">
                                                    <i class="mr-1 far fa-file-excel"></i> {{row.year}}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="overflow-x-auto text-sm tabular-nums" v-if="model">
                    <div class="min-w-[850px]">
                        <p v-if="!hasData">
                            {{translate('geen_jaarrekeningen')}}
                        </p>
                        <financial-row v-for="(row, index) in model.rows" :row="row" :key="'jr_row_' + index"></financial-row>
                    </div>
                </div>
            </template>
            <no-access v-else :sub-page="SubPage.FINANCIAL_STATEMENTS"></no-access>
        </div>
    </section>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {FinancialStatementsModel, SubPage} from "../types";
import {useDetailStore} from "../store";
import FinancialRow from './financial-statements/row.vue';
import NoAccess from "./no-access.vue";

export default defineComponent({
    name: "financial-statements",
    components: {NoAccess, FinancialRow},
    data() {
        return {
            detailStore: useDetailStore(),
            isMenuOpen: false,
            SubPage
        }
    },
    computed: {
        hasPermission(): boolean {
            return this.detailStore.canSeePaidComponents;
        },
        model(): FinancialStatementsModel {
            return this.detailStore.pageModel[SubPage.FINANCIAL_STATEMENTS]!;
        },
        hasData(): boolean {
            return (this.model?.rows.length ?? 0) > 0;
        }
    }
});
</script>

